import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// What page sits at each step of this tab's history (react-router keeps the step number in history.state.idx).
// Back buttons use it to skip entries of the SAME page (tab / filter / date changes, a login page that bounces back)
// and land on the previous different screen in one press.
const KEY = "nav:paths";
const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch (e) { return {}; } };
const idx = () => window.history.state?.idx ?? 0;

export function useNavTracker() {
  const loc = useLocation();
  useEffect(() => {
    const m = read(); const i = idx();
    m[i] = loc.pathname;
    for (const k of Object.keys(m)) if (Number(k) > i) delete m[k];  // a new page cuts off the old "forward" entries
    try { sessionStorage.setItem(KEY, JSON.stringify(m)); } catch (e) { /* storage full / private mode: Back falls back to -1 */ }
  }, [loc.key, loc.pathname]);
}

export function NavTracker() { useNavTracker(); return null; }

// How many steps back to the previous different page that `ok(path)` accepts; 0 = none in this tab.
export function stepsBack(ok = () => true) {
  const m = read(); const i = idx(); const here = window.location.pathname;
  for (let j = i - 1; j >= 0; j--) {
    const p = m[j];
    if (p === undefined) return j === i - 1 ? 1 : 0;  // unknown (storage lost): plain one step
    if (p !== here && ok(p)) return i - j;
  }
  return 0;
}

// Login / join pages: never step back onto them while signed in.
export const isLoginPath = (p) => /^\/(login|staff-login|join|family\/login|register|forgot-password|reset-password|demo\/)/.test(p);
